"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationClassNames = void 0;
var index_1 = require("../utilities/index");
var index_2 = require("../styles/index");
/**
 * {@docCategory AnimationClassNames}
 */
exports.AnimationClassNames = (0, index_1.buildClassMap)(index_2.AnimationStyles);
//# sourceMappingURL=AnimationClassNames.js.map